import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { MeetDeleteDialog } from '../../../../dialogs/MeetDeleteDialog/MeetDeleteDialog'
import { MeetEditDialog } from '../../../../dialogs/MeetEditDialog/MeetEditDialog'
import { RecordStopDialog } from '../../../../dialogs/RecordStopDialog/RecordStopDialog'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'
import { MeetingStatus } from '../../../../swagger/dto'

export const MeetingItemMenu = ({ idMeeting, status, source }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [openStopRecordingDialog, setOpenStopRecordingDialog] = React.useState<boolean>(false)
    const [openEditBotToMeetDialog, setOpenEditBotToMeetDialog] = React.useState<boolean>(false)
    const [openRemoveMeetingDialog, setOpenRemoveMeetingDialog] = React.useState<boolean>(false)
    const open = Boolean(anchorEl)
    const { setIdActiveEditRecord } = useAssistantAdministrationStore((state) => state)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setIdActiveEditRecord(undefined)
        setOpenStopRecordingDialog(false)
        setAnchorEl(null)
    }

    const handleClickOpenEditBotToMeetDialog = () => {
        setOpenEditBotToMeetDialog(true)
    }

    const handleCloseEditBotToMeetDialog = () => {
        setOpenEditBotToMeetDialog(false)
    }

    const handleClickOpenStopRecordingDialog = () => {
        setOpenStopRecordingDialog(true)
    }

    const handleClickOpenRemoveMeetingDialog = () => {
        setOpenRemoveMeetingDialog(true)
    }

    const handleCloseOpenRemoveMeetingDialog = () => {
        setOpenRemoveMeetingDialog(false)
    }

    return (
        <>
            <IconButton
                sx={{
                    '&:hover': { borderColor: '#F4F4F6' },
                    position: 'absolute',
                    top: '12px',
                    right: '12px',
                    background: ' #fff',
                    zIndex: 1000,
                }}
                variant="text"
                color="primary"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {status === MeetingStatus.SCHEDULED && (
                    <MenuItem onClick={handleClickOpenEditBotToMeetDialog}>
                        <ListItemText
                            primary={<Typography variant="body">Редактировать</Typography>}
                        />
                        <ModeEditOutlineOutlinedIcon fontSize="small" />
                    </MenuItem>
                )}

                {status === MeetingStatus.PROCESSING && (
                    <MenuItem onClick={handleClickOpenStopRecordingDialog}>
                        <ListItemText
                            primary={
                                <Typography variant="body" style={{ color: '#CA1616' }}>
                                    Отключить бота
                                </Typography>
                            }
                        />
                        <DeleteOutlinedIcon fontSize="small" style={{ color: '#CA1616' }} />
                    </MenuItem>
                )}
                {status !== MeetingStatus.PROCESSING && (
                    <MenuItem onClick={handleClickOpenRemoveMeetingDialog}>
                        <ListItemText
                            primary={
                                <Typography variant="body" style={{ color: '#CA1616' }}>
                                    Удалить
                                </Typography>
                            }
                        />
                        <DeleteOutlinedIcon fontSize="small" style={{ color: '#CA1616' }} />
                    </MenuItem>
                )}
            </Menu>
            {openStopRecordingDialog && idMeeting && (
                <RecordStopDialog
                    open={openStopRecordingDialog}
                    handleClose={handleClose}
                    id={idMeeting}
                />
            )}

            {openEditBotToMeetDialog && (
                <MeetEditDialog
                    idMeeting={idMeeting}
                    source={source}
                    open={openEditBotToMeetDialog}
                    handleClose={handleCloseEditBotToMeetDialog}
                />
            )}

            {openRemoveMeetingDialog && (
                <MeetDeleteDialog
                    id={idMeeting}
                    open={openRemoveMeetingDialog}
                    handleClose={handleCloseOpenRemoveMeetingDialog}
                />
            )}
        </>
    )
}
